module.exports = __webpack_public_path__ + "18266c07.otf";